class BundleMediaGallery extends HTMLElement {
  connectedCallback() {
    const mainEl = this.querySelector('[data-carousel-main]');
    const thumbsEl = this.querySelector('[data-carousel-thumbs]');
    if (!mainEl || !thumbsEl) return;

    const thumbsSwiper = new Swiper(thumbsEl, {
      spaceBetween: 8,
      slidesPerView: 3,
      watchSlidesProgress: true,
      watchOverflow: false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next',
        // Preserve the native list semantics of the thumbnail gallery.
        slideRole: 'listitem',
      },
      breakpoints: {
        768: { slidesPerView: 3, enabled: true },
      },
    });

    new Swiper(mainEl, {
      spaceBetween: 10,
      loop: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next',
        slideRole: 'listitem',
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: thumbsEl.querySelector('.swiper-button-next'),
        prevEl: thumbsEl.querySelector('.swiper-button-prev'),
      },
    });
  }
}

customElements.define('bundle-media-gallery', BundleMediaGallery);
